import HiddenOverlay from './Hidden';
import HiddenOverlayContainer from './Hidden.container';
export default HiddenOverlayContainer(HiddenOverlay);
//# sourceMappingURL=index.js.map